
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import Toast from 'vue-toastification';
import { store } from './store';
import 'vue-toastification/dist/index.css';

const app = createApp(App);
app.use(router);
app.use(Toast);
app.use(store);
app.mount('#app');


